import {useCallback, useEffect, useState} from "react"
import {getAllJobOffers, IJobOffer, IJobOfferFilters} from "../api/jobOffers";

/**
 * Hook para obtener todas las ofertas de empleo
 */
export function useJobOffers() {
    const [jobOffers, setJobOffers] = useState<IJobOffer[]>([]);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [inProgress, setInProgress] = useState<boolean>(true);
    const [hasError, setHasError] = useState<boolean>(false);

    const [filters, setFilters] = useState<IJobOfferFilters>();
    const [currentPage, setCurrentPage] = useState<number>(1);

    const refreshData = useCallback(() => {
        setInProgress(true);
        setHasError(false);
        getAllJobOffers(filters, currentPage - 1)
            .then(result => {
                setJobOffers(result.data);
                setTotalPages(result.totalPages);
                setCurrentPage(result.currentPage + 1);
            })
            .catch((err) => {
                setHasError(true);
            })
            .finally(() => {
                setInProgress(false);
            });
    }, [filters, currentPage]);

    useEffect(() => {
        refreshData();
        // eslint-disable-next-line
    }, []);

    return {jobOffers, totalPages, currentPage, inProgress, hasError, refreshData, setFilters, setCurrentPage};
}